import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/partners/join-referral-network/#webpage",
   "url": "https://www.futurefamilyai.com/partners/join-referral-network/",
   "name": "Join the Referral Network Free | FutureFamilyAI",
   "description": "List your clinic, agency or practice free. Published eligibility, verification and ranking rules. Apply in minutes.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Partner Directory",
     "item": "https://www.futurefamilyai.com/partners/directory/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Join Referral Network",
     "item": "https://www.futurefamilyai.com/partners/join-referral-network/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is there a fee to join?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No."
     }
    },
    {
     "@type": "Question",
     "name": "How long does verification take?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Typically a few business days."
     }
    },
    {
     "@type": "Question",
     "name": "Can individual clinicians join?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes."
     }
    },
    {
     "@type": "Question",
     "name": "Do we have to refer patients?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No referral obligations."
     }
    },
    {
     "@type": "Question",
     "name": "Can we edit our listing?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, at any time."
     }
    },
    {
     "@type": "Question",
     "name": "Do you share patient data with partners?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only with patient consent."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function PartnersJoinReferralNetworkPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/partners/directory">Partner Directory</Link>
              <span>›</span>
              <span>Join Referral Network</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                IVF clinics, surrogacy agencies and clinicians can join the
                FutureFamilyAI Referral Network at no cost.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>IVF clinics, agencies &amp; clinicians</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Assisted reproductive technology contributes to roughly 2%
                      of U.S. births each year. (CDC ART Surveillance)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Free listing · Published, non-paid ranking · Patient
                      materials included
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PARTNER NETWORK</span>
            <h1>Join the FutureFamilyAI Referral Network — No Fees</h1>
            <p className="ffh-answer speakable-content">
              IVF clinics, surrogacy agencies and clinicians can join the
              FutureFamilyAI Referral Network at no cost. After credential
              verification, you receive a directory listing families can find,
              patient education materials and the option to invite patients to
              the free pilot. Listing order follows published, non-paid
              criteria. Joining takes only a few minutes, and there are no
              referral quotas or obligations. Apply to join in minutes.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Fertility clinic leaders joining the FutureFamilyAI referral network"
              >
                <figcaption>
                  <b>Photo slot</b> · Two clinic leaders shaking hands in a
                  bright lobby, friendly and professional. No logos.
                  <br />
                  <b>Alt:</b> Fertility clinic leaders joining the
                  FutureFamilyAI referral network
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Assisted reproductive technology contributes to roughly 2%
                    of U.S. births each year.
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/art/">
                        CDC ART Surveillance
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>How to join</h2>
                <ul>
                  <li>Submit the partner application</li>
                  <li>We verify licensure and credentials</li>
                  <li>Your listing goes live</li>
                  <li>Invite patients with your partner link</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Application fields</h2>
                <ul>
                  <li>Organization name, type, address, website</li>
                  <li>Services offered and states served</li>
                  <li>License/registration numbers</li>
                  <li>Primary contact</li>
                  <li>Agreement to directory terms</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Is there a fee to join?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>No.</p>
                    </div>
                  </details>
                  <details>
                    <summary>How long does verification take?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>Typically a few business days.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can individual clinicians join?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>Yes.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Do we have to refer patients?</summary>
                    <div className="ffh-ans">
                      <p>No referral obligations.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can we edit our listing?</summary>
                    <div className="ffh-ans">
                      <p>Yes, at any time.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Do you share patient data with partners?</summary>
                    <div className="ffh-ans">
                      <p>Only with patient consent.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/partners/directory">Partner Directory →</Link>
                  <Link to="/partners">For IVF Clinics &amp; Agencies →</Link>
                  <Link to="/partners/ivf-clinic-partnership">
                    IVF Clinic Partnership →
                  </Link>
                  <Link to="/partners/surrogacy-agency-partnership">
                    Surrogacy Agency Partnership →
                  </Link>
                  <Link to="/partners/no-fee-directory-faq">
                    No-Fee Directory FAQ →
                  </Link>
                  <Link to="/partners/find-a-provider">Find a Provider →</Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">How to join</a>
                  </li>
                  <li>
                    <a href="#s2">Application fields</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
